class JudgeMeReviews extends HTMLElement {
  constructor() {
    super();
    // Get credentials from metafields via global config
    this.apiToken = window.JudgeMeConfig?.apiToken || '';
    this.shopDomain = window.JudgeMeConfig?.shopDomain || '';
    this.bearerToken = window.JudgeMeConfig?.bearerToken || '';
  }

  connectedCallback() {
    this.render();
    
    // Detect if we are on home or PDP
    const isHomePage = window.location.pathname === '/' || window.location.pathname === '/home';
    const isProductPage = window.location.pathname.includes('/products/');
    
    if (isHomePage) {
      // On home, maintain current functionality
      this.fetchReviews();
    } else if (isProductPage) {
      // On PDP, find Judge.me badge and extract data
      this.extractReviewsFromBadge();
    } else {
      // On other pages, default behavior
      this.fetchReviews();
    }
  }

  render() {
    this.innerHTML = `
      <div class="rating-container">
        <div class="rating-value" id="rating-value">5.0</div>
        <div class="stars-container" id="stars-container">
          <span class="star filled">★</span>
          <span class="star filled">★</span>
          <span class="star filled">★</span>
          <span class="star filled">★</span>
          <span class="star filled">★</span>
        </div>
        <div class="review-count" id="review-count">(0)</div>
      </div>
    `;
  }

  async fetchReviews() {
    try {
      const productId = this.getAttribute('product-id') || '';
      let baseUrl = `https://judge.me/api/v1/reviews/count?api_token=${this.apiToken}&shop_domain=${this.shopDomain}`;

      // const ratingResponse = await fetch(baseUrl);
      // const ratingData = await ratingResponse.json();

      const countResponse = await fetch(baseUrl + '&rating=5');
      const countData = await countResponse.json();

      this.updateDisplay({
        // rating: ratingData.rating,
        count: countData.count
      });
    } catch (error) {
      console.error('Error fetching Judge.me reviews:', error);
    }
  }

  extractReviewsFromBadge() {
    // Use setTimeout to wait for Judge.me to load its badge
    const checkForBadge = () => {
      const productGrid = document.querySelector('.grid.product-single');
      const badge = productGrid ? productGrid.querySelector('.jdgm-prev-badge__text') : null;
      
      if (badge) {
        // Extract number from text (e.g., "28 reviews" -> 28)
        const badgeText = badge.textContent || '';
        const reviewNumber = badgeText.match(/\d+/);
        
        // Find stars element to extract data-score
        const starsElement = productGrid.querySelector('.jdgm-prev-badge__stars');
        
        if (starsElement) {
          const dataScore = starsElement.getAttribute('data-score');
          
          // Update rating-value with data-score
          const ratingValue = this.querySelector('#rating-value');
          if (ratingValue && dataScore) {
            ratingValue.textContent = dataScore;
          }
        }
        
        if (reviewNumber) {
          // Update review-count element with extracted number
          const reviewCount = this.querySelector('#review-count');
          if (reviewCount) {
            reviewCount.textContent = `(${reviewNumber[0]})`;
          }
        }
      } else {
        // If badge not found, retry after a brief delay
        setTimeout(checkForBadge, 500);
      }
    };
    
    // Start checking after a brief delay to allow DOM to load
    setTimeout(checkForBadge, 100);
  }

  updateDisplay(data) {
    const ratingValue = this.querySelector('#rating-value');
    const starsContainer = this.querySelector('#stars-container');
    const reviewCount = this.querySelector('#review-count');
    if (ratingValue) {
      ratingValue.textContent = '5.0';
    }

    if (starsContainer) {
      const stars = starsContainer.querySelectorAll('.star');
      stars.forEach((star) => {
        star.className = 'star filled';
        star.textContent = '★';
      });
    }

    if (reviewCount) {
      reviewCount.textContent = `(${data.count || 0})`;
    }
  }
}

customElements.define('judge-me-reviews', JudgeMeReviews);